export enum ActionTypes {
    getAll = 'getAll',
    get = 'get',
    resetError = 'resetError',
    resetSuccess = 'resetSuccess',
    loading = 'loading'
  }